import {
    generateUUID2, getSafeInt,
    isAudioFileElement,
    isDarkMode,
    isFileElement,
    isFileVideoElement, isHTML,
    isLiveVideoElement,
    isNoteElement,
    isPdfFileElement,
    removeHtmlTags
} from "@/utils";
import {
    isEmbeddableElement,
    isFrameElement, isImageElement,
    isMindmapElement, isProjectLinkElement,
    isStickyNotesElement,
    isTextElement
} from "../@excalidraw/packages/excalidraw/element/typeChecks";
import { t } from "i18next";
import {ARRAY_CARD_DEFAULT_COLORS} from "@/ColorUtility";
import {
    getAudioElementIcon,
    getCardElementIcon,
    getFileElementIcon,
    getFrameElementIcon,
    getImageElementIcon,
    getMindmapElementIcon,
    getOnlineVideoElementIcon,
    getPdfElementIcon,
    getPdfElementIconForBookmarkForBookmarkForBookmark,
    getProjectElementIcon,
    getStickNoteElementIcon,
    getTextElementIcon,
    getVideoElementIcon,
    getWebLinkElementIcon
} from "@/Icon";
import {getFrameElementBackgroundColor} from "@/Const";
import {getCardTitle0} from "@/Utility0";
import {mutateElement} from "../@excalidraw/packages/excalidraw";
import {getProjectContentFilter} from "@model/projectContentFilter";
import {PROJECT_ID} from "@/views/Draw/DrawIndex";
import {getSysConfig} from "@model/sysconfig";

/**
 * 是否这个元素应该显示在content列表中.
 * @param element
 */
export const isElementInContent = (element:any)=>{
    return isNoteElement(element) ||
        isMindmapElement(element) ||
        isStickyNotesElement(element) ||
        isFrameElement(element) ||
        isImageElement(element) ||
        isPdfFileElement(element) ||
        isFileVideoElement(element) ||
        isLiveVideoElement(element) ||
        isTextElement(element) ||
        isFileElement(element) ||
        isProjectLinkElement(element) ||
        isEmbeddableElement(element);
}

/**
 * 取元素的图标
 * @param element
 * @param szHexColor
 */
export const getElementIcon = (element:any,szHexColor:any,isMaginIcon=false)=>{
    if (szHexColor == '#E2E2E2'){
        szHexColor = '#838C97';
    }
    if (isNoteElement(element)){
        return getCardElementIcon(szHexColor);
    }else if (isFrameElement(element)){
        return getFrameElementIcon(szHexColor);
    }else if (isMindmapElement(element)){
        return getMindmapElementIcon(szHexColor);
    }else if (isStickyNotesElement(element)){
        return getStickNoteElementIcon(szHexColor);
    }else if (isImageElement(element)){
        return getImageElementIcon(szHexColor);
    }else if (isProjectLinkElement(element)){
        return getProjectElementIcon(szHexColor);
    }else if (isPdfFileElement(element)){
        // if (isMaginIcon){
        //     return getPdfElementIconForBookmarkForBookmarkForBookmark(szHexColor);
        // }
        return getPdfElementIcon(szHexColor);
    }else if (isLiveVideoElement(element)){
        return getOnlineVideoElementIcon(szHexColor);
    }
    else if (isFileVideoElement(element)){
        return getVideoElementIcon(szHexColor);
    }else if (isTextElement(element)){
        return getTextElementIcon(szHexColor);
    }else if (isAudioFileElement(element)){
        return getAudioElementIcon(szHexColor);
    }
    else if (isFileElement(element)){
        return getFileElementIcon(szHexColor)
    }else if (isEmbeddableElement(element)){
        return getWebLinkElementIcon(szHexColor);
    }
    return ''
}

export const getElementTitle = (element)=>{
    let szTitle = '';
    if (isNoteElement(element)){
        if (element.customData?.generationData?.name){
            szTitle = element.customData?.generationData?.name;
        }else{
            szTitle = getCardTitle0({type:'card',name:'',thumbHtml:element.customData?.generationData?.html})//removeHtmlTags(element.customData?.generationData?.html) || t("Untitled");
        }
    }else if (isStickyNotesElement(element)){
        if (element.customData?.generationData?.html){
            szTitle = getCardTitle0({type:'card',name:'',thumbHtml:element.customData?.generationData?.html})
        }else{
            if (isHTML(element.value)){
                szTitle = getCardTitle0({type:'card',name:'',thumbHtml:element.value})
            }else{
                szTitle = removeHtmlTags(element.value);
            }

        }
    }else if (isTextElement(element)){
        szTitle = removeHtmlTags(element.value) || removeHtmlTags(element.text) || t('Untitled');
    }else if (isMindmapElement(element)){
        szTitle = removeHtmlTags(element.data?.data?.text);
    }else if (isLiveVideoElement(element)){
        szTitle = element.customData?.generationData?.name;
    }else if (isImageElement(element)){
        if (element.customData?.generationData?.isShowInfoNotes && element.customData?.generationData?.infoNotes && !element.customData?.generationData?.isShowName){
            szTitle = element.customData?.generationData?.infoNotes
        }else{
            szTitle = element.name;
        }
    }
    else{
        szTitle = element.name;
    }
    return szTitle;
}

export const getElementColor = (element)=>{
    let szColor = '#393834';
    if (isNoteElement(element)){
        szColor = element.backgroundColor;
        //这个颜色还要转换一道...
        for (let i=0;i<ARRAY_CARD_DEFAULT_COLORS.length;i++){
            const item = ARRAY_CARD_DEFAULT_COLORS[i];
            if (item.useBackgroundColor == szColor || item.useDarkBackgroundColor == szColor){
                szColor = item.background;
            }
        }
    }else if (isFrameElement(element)){
        // szColor = element.backgroundColor;
    }else if (isFileElement(element) || isImageElement(element)){
        szColor = element.strokeColor;
    }

    if (!szColor ||
        szColor?.toLowerCase() == 'white' ||
        szColor?.toLowerCase() == 'transparent' ||
        szColor == '#00000000' || szColor == '#000000' || szColor == '#F0EFF5' || szColor == getFrameElementBackgroundColor() ||
        szColor == '#FFFFFF' || szColor == '#ffffff'){
        szColor = '#393834';
    }

    if (isDarkMode()){
        if (szColor == '#393834' || szColor?.toLowerCase() == '#2c2c2c' ||
            szColor == '#000000' || szColor?.toLowerCase() == '#F0EFF5' || szColor == getFrameElementBackgroundColor()){
            szColor = '#E2E2E2';
        }
    }
    return szColor;
}


export const convertTextToTiptap=(element)=> {
    let szConvertHtml=`<p data-id="${generateUUID2()}" ifhidden="false" class="has-focus">`;
    if (isHTML(element.text)){
        return element.text;
    }
    if (element.richText){
        for (let i=0;i<element.richText.length;i++) {
            const item = element.richText[i];
            let szItemHtml = `<span style="color:${item.color}">`;
            let szStyle = '';
            if (item.bold) {
                szStyle = (`<strong>{0}</strong>`)
            }
            if (item.italic) {
                if (szStyle) {
                    szStyle = szStyle.replace('{0}', '<em>{0}</em>')
                } else {
                    szStyle = (`<em>{0}</em>`)
                }
            }
            if (item.underline) {
                if (szStyle) {
                    szStyle = szStyle.replace('{0}', '<u>{0}</u>')
                } else {
                    szStyle = (`<u>{0}</u>`)
                }
            }
            if (item.strikeout) {
                if (szStyle) {
                    szStyle = szStyle.replace('{0}', '<s>{0}</s>')
                } else {
                    szStyle = (`<s>{0}</s>`)
                }
            }
            if (szStyle) {
                szStyle = szStyle.replace('{0}', item.value);
            } else {
                szStyle = item.value;
            }
            szItemHtml += szStyle + '</span>'
            szConvertHtml += szItemHtml;
        }
        szConvertHtml += '</p>'
    }else{
        szConvertHtml = element.text || element.value;
    }
    //如果背景是白色就换成透明色.
    if (element.richText && element.backgroundColor){
        mutateElement(element,{backgroundColor:'transparent'});
    }
    return szConvertHtml;
}


/**
 * 排序frame元素.
 * @param arrayElements
 * @param contentFilterSort
 */
const orderElement = (arrayElements:any,contentFilterSort)=>{
    const szSortType = contentFilterSort?.sortBy || 'sort by createDate';
    const szOrderBy = contentFilterSort?.orderBy || 'date desc';
    if("sort by name" === szSortType){
        if("a-z" === szOrderBy){
            arrayElements.sort((a,b)=>{
                const iA = getSafeInt(a.name);
                const iB = getSafeInt(b.name);
                if (iA != 0 && iB != 0){
                    return iA - iB;
                }
                return a.name.localeCompare(b.name);
            })
        }else if("z-a" == szOrderBy){
            arrayElements.sort((a,b)=>{
                const iA = getSafeInt(a.name);
                const iB = getSafeInt(b.name);
                if (iA != 0 && iB != 0){
                    return iB - iA;
                }
                return b.name.localeCompare(a.name);
            })
        }
    }else if("sort by createDate" == szSortType){
        if("date asc" == szOrderBy){
            arrayElements.sort((a,b)=>{
                if (a.created && b.created){
                    return a.created - b.created;
                }
                return 0;
            })
        }else if("date desc" == szOrderBy){
            arrayElements.sort((a,b)=>{
                if (a.created && b.created){
                    return b.created - a.created;
                }
                return -1;
            })
        }
    } else if("sort by updateDate" == szSortType){
        if("date asc" == szOrderBy){
            arrayElements.sort((a,b)=>{
                return a.updated - b.updated;
            })
        }else if("date desc" == szOrderBy){
            arrayElements.sort((a,b)=>{
                return b.updated - a.updated;
            })
        }
    }
}
export async function sortFramePresent(szBoardId:any,arrayNew:any){
    const contentFilterSort = await getProjectContentFilter(PROJECT_ID);
    orderElement(arrayNew,contentFilterSort);
    let arrayNewFrames = [...arrayNew];

    const frameIds = await getSysConfig(szBoardId);
    if (frameIds){
        const arrayNewNew:any = [];
        const arrayIds = JSON.parse(frameIds.value);
        //按这个顺序调整....
        for (let i=0;i<arrayIds.length;i++){
            const szId = arrayIds[i];
            const ele = arrayNew.find(p=>p.id == szId);
            if (ele){
                arrayNewNew.push(ele);
            }
        }
        //把没有的加进来....
        for (let i=0;i<arrayNew.length;i++){
            if (!arrayNewNew.some(p=>p.id == arrayNew[i].id)){
                arrayNewNew.push(arrayNew[i]);
            }
        }
        arrayNewFrames = arrayNewNew;
    }
    return arrayNewFrames;
}





































